export default __webpack_public_path__ + "static/media/TopicsLogoSymbol.fa79029f.svg";